













































































































































































































import { default as Component } from 'vue-class-component';

import PaymentWidget from '@/components/widgets/PaymentWidget.vue';
import MessagesBlock from '@/components/snippets/messages/MessagesBlock.vue';

import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';

import Api from '@/interfaces/Api';
import Tracking from '@/interfaces/Tracking';

const ApiProvider = IocContainer.get<Api>(SERVICES.API);
const trackingProvider = IocContainer.get<Tracking>(SERVICES.TRACKING);

@Component({
  props: {
    isMobile: Boolean
  },
  components: {
    'messages-block': MessagesBlock
  }
})
export default class HsgPaymentWidget extends PaymentWidget {
  get isErrorAlternativeAccountHolder(): boolean {
    return (
      typeof this.errorHsgAlternativeAccountHolder !== 'undefined' && this.errorHsgAlternativeAccountHolder !== null
    );
  }
  get errorHsgAlternativeAccountHolder(): { key: string; message: string }[] | null {
    return this.getHsgError('alternativeAccountHolder');
  }

  get isErrorIban(): boolean {
    return typeof this.errorHsgIban !== 'undefined' && this.errorHsgIban !== null;
  }
  get errorHsgIban(): { key: string; message: string }[] | null {
    return this.getHsgError('iban');
  }

  get isErrorBic(): boolean {
    return typeof this.errorHsgBic !== 'undefined' && this.errorHsgBic !== null;
  }
  get errorHsgBic(): { key: string; message: string }[] | null {
    return this.getHsgError('bic');
  }

  get isErrorBank(): boolean {
    return typeof this.errorHsgBank !== 'undefined' && this.errorHsgBank !== null;
  }
  get errorHsgBank(): { key: string; message: string }[] | null {
    return this.getHsgError('bank');
  }

  get isErrorDirectDebitConsent(): boolean {
    return typeof this.errorHsgDirectDebitConsent !== 'undefined' && this.errorHsgDirectDebitConsent !== null;
  }
  get errorHsgDirectDebitConsent(): { key: string; message: string }[] | null {
    return this.getHsgError('directDebitConsent');
  }

  public getHsgError(fieldName: string): [{ key: string; message: string }] | null {
    if (!this.errorsBag) {
      return null;
    }
    return typeof this.errorsBag[fieldName] === 'object' ? this.errorsBag[fieldName] : null;
  }

  public paymentSubmit(): void {
    this.errorsBag = null;

    if (
      this.paymentData.iban === null ||
      this.paymentData.iban === '' ||
      (this.paymentData.iban !== '' && this.paymentData.bank !== '' && this.paymentData.bic !== '')
    ) {
      if (this.paymentData.directDebit && this.paymentData.iban === '') {
        this.setErrorsBag(
          'iban',
          'payment.widget.sepa.direct.debit.error1',
          this.$t('payment.widget.sepa.direct.debit.error1').toLocaleString()
        );
      } else if (this.paymentData.directDebit && !this.paymentData.directDebitConsent) {
        this.setErrorsBag(
          'directDebitConsent',
          'payment.widget.sepa.direct.debit.error2',
          this.$t('payment.widget.sepa.direct.debit.error2').toLocaleString()
        );
      } else {
        if (!this.paymentData.directDebit) {
          this.paymentData.alternativeAccountHolder = '';
        }
        ApiProvider.sessionUpdate(this.paymentData)
          .then(() => {
            ApiProvider.validatePayment()
              .then(() => {
                trackingProvider.validationPaymentSuccessful(
                  this.sessionState,
                  this.$props.product,
                  this.paymentData.iban
                );
                this.$emit('paymentSubmit', this.paymentData);
              })
              .catch((error) => {
                trackingProvider.validationPaymentFailed();
                this.errorsBag = error.response.data.error.messages;
              });
          })
          .catch((error) => {
            if (typeof error.response !== 'undefined' && error.response.data.error.message === 'session outdated') {
              localStorage.removeItem(process.env.VUE_APP_SESSION_STORAGE_KEY);
              window.location.href = document.referrer || window.location.origin;
            }
          });
      }
    } else {
      this.setErrorsBag(
        'iban',
        'payment.widget.sepa.direct.debit.error3',
        this.$t('payment.widget.sepa.direct.debit.error3').toLocaleString()
      );
    }
  }

  public updateBicAndBank(): void {
    if (this.paymentData.iban.length >= 15) {
      this.bicBankLoading = true;
      this.errorMessage = '';
      clearTimeout(this.bicAndBankTimeout);
      this.bicAndBankTimeout = setTimeout(() => {
        ApiProvider.getBicAndBank(this.paymentData.iban)
          .then((response) => {
            this.bicBankLoading = false;
            if (response.data.success) {
              this.paymentData.bic = response.data.bic;
              this.paymentData.bank = response.data.bank;
            } else {
              this.setErrorsBag(
                'iban',
                'payment.widget.sepa.direct.debit.error4',
                this.$t('payment.widget.sepa.direct.debit.error4').toLocaleString()
              );
            }
          })
          .catch(() => {
            this.bicBankLoading = false;
            this.setErrorsBag(
              'iban',
              'payment.widget.sepa.direct.debit.error4',
              this.$t('payment.widget.sepa.direct.debit.error4').toLocaleString()
            );
          });
      }, 2000);
    } else {
      this.paymentData.bic = '';
      this.paymentData.bank = '';
      this.bicBankLoading = false;
    }
  }

  protected choiceConditions() {
    if (this.paymentData.directDebitConsent) {
      this.paymentData.directDebitConsent = false;
    }
  }

  private setErrorsBag(errorKey: string, localeKey: string, message: string) {
    if (typeof this.errorsBag === 'undefined' || this.errorsBag === null) {
      this.errorsBag = {
        [errorKey]: [
          {
            key: localeKey,
            message
          }
        ]
      };
    } else {
      this.errorsBag[errorKey] = [
        {
          key: localeKey,
          message
        }
      ];
    }
  }
}
